// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar[data-v-4ba7e1d6] {
  border-bottom: 1px solid var(--border-bottom-section);
}
.toolbar-wrapper[data-v-4ba7e1d6] {
  display: flex;
  margin-bottom: 10px;
  margin-top: 6px;
  height: 54px;
}
.toolbutton[data-v-4ba7e1d6] {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 60px;
  margin-top: 5px;
  border: none;
  border-radius: 5px;
  color: var(--toolbtn-color);
  outline: none;
  font-size: 1.8em;
  cursor: pointer;
}
.toolbutton i[data-v-4ba7e1d6] {
  margin: auto;
  font-weight: lighter;
}
.toolbutton span[data-v-4ba7e1d6] {
  font-size: 12px;
  text-align: center;
  margin-top: 5px;
}
.toolbutton .fa-phone[data-v-4ba7e1d6]:after {
  left: -10px;
  top: -12px;
  transform: rotate(-90deg);
}
.toolbutton[data-v-4ba7e1d6]:hover,
.toolbutton.active[data-v-4ba7e1d6] {
  color: var(--toolbtn-active-color);
}
.toolbutton:hover i[data-v-4ba7e1d6]:not(.fa-equals),
.toolbutton.active i[data-v-4ba7e1d6]:not(.fa-equals) {
  font-weight: bold;
}
i[data-count][data-v-4ba7e1d6]::after {
  content: attr(data-count);
  position: absolute;
  top: 1px;
  left: 50px;
  transform: translate(-75%, -50%);
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: white;
  font-size: 12px;
  line-height: 18px;
  height: 20px;
  width: 20px;
  vertical-align: middle;
  margin: auto;
  padding-right: 1px;
  border-radius: 13px;
  background: var(--badge-red-color);
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/side/Toolbar.vue"],"names":[],"mappings":"AAAA;EACE,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,2DAA2D;EAC3D,mBAAmB;AACrB","sourcesContent":[".toolbar[data-v-4ba7e1d6] {\n  border-bottom: 1px solid var(--border-bottom-section);\n}\n.toolbar-wrapper[data-v-4ba7e1d6] {\n  display: flex;\n  margin-bottom: 10px;\n  margin-top: 6px;\n  height: 54px;\n}\n.toolbutton[data-v-4ba7e1d6] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  width: 60px;\n  margin-top: 5px;\n  border: none;\n  border-radius: 5px;\n  color: var(--toolbtn-color);\n  outline: none;\n  font-size: 1.8em;\n  cursor: pointer;\n}\n.toolbutton i[data-v-4ba7e1d6] {\n  margin: auto;\n  font-weight: lighter;\n}\n.toolbutton span[data-v-4ba7e1d6] {\n  font-size: 12px;\n  text-align: center;\n  margin-top: 5px;\n}\n.toolbutton .fa-phone[data-v-4ba7e1d6]:after {\n  left: -10px;\n  top: -12px;\n  transform: rotate(-90deg);\n}\n.toolbutton[data-v-4ba7e1d6]:hover,\n.toolbutton.active[data-v-4ba7e1d6] {\n  color: var(--toolbtn-active-color);\n}\n.toolbutton:hover i[data-v-4ba7e1d6]:not(.fa-equals),\n.toolbutton.active i[data-v-4ba7e1d6]:not(.fa-equals) {\n  font-weight: bold;\n}\ni[data-count][data-v-4ba7e1d6]::after {\n  content: attr(data-count);\n  position: absolute;\n  top: 1px;\n  left: 50px;\n  transform: translate(-75%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  color: white;\n  font-size: 12px;\n  line-height: 18px;\n  height: 20px;\n  width: 20px;\n  vertical-align: middle;\n  margin: auto;\n  padding-right: 1px;\n  border-radius: 13px;\n  background: var(--badge-red-color);\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
